window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    /**
     * @type {import("maplibre-gl").Marker[]}
     */
    let markers = [];

    /**
     * @type {MapRenderer}
     */
    let map;

    let currentCityTab =
      window.theme.campFinderWidget.pageCityName ??
      window.theme.campFinderWidget.firstCity;

    let filters = {
      week: 'all',
      sport: window.theme.campFinderWidget.pageSportName ?? 'all',
      city: 'all',
    };

    function getMapWrapper() {
      return window.innerWidth > 1280
        ? $('.result-column.map')
        : $('.camp-list__map-overlay .map');
    }

    function processInitialFilters(initialFilters) {
      let $highestPriorityFilter = $('.camp-list__filter-slide').eq(0);

      // Select filter with highest sort priority
      $('.camp-list__filter-slide[data-sort-priority]').each(function () {
        let $filter = $(this);

        if (!$filter.data('sort-priority')) return;

        // Compare this filter's sort priority to the highest priority filter
        if (
          parseInt($filter.data('sort-priority')) >
          parseInt($highestPriorityFilter.data('sort-priority') ?? 0)
        ) {
          $highestPriorityFilter = $filter;
        }
      });

      $highestPriorityFilter.toggleClass('active', true);

      if (document.body.classList.contains('page-find-a-camp-location')) {
        window.theme.campFinderWidget.firstSport = $highestPriorityFilter
          .text()
          .trim();
      } else if (
        document.body.classList.contains('page-find-a-camp-sport') ||
        document.body.classList.contains('page-find-a-camp-sport-partner')
      ) {
        window.theme.campFinderWidget.firstCity = $highestPriorityFilter
          .text()
          .trim();
      }

      // Start by loading in the details from the page
      if (window?.theme?.campFinderWidget?.pageCityName) {
        initialFilters.city = window.theme.campFinderWidget.pageCityName;
      }

      if (window?.theme?.campFinderWidget?.pageSportName) {
        initialFilters.sport = window.theme.campFinderWidget.pageSportName;
      }

      // Then check if we loaded any additional filters from the DOM
      if (window?.theme?.campFinderWidget?.firstCity) {
        initialFilters.city = window.theme.campFinderWidget.firstCity;
      }

      if (window?.theme?.campFinderWidget?.firstSport) {
        initialFilters.sport = window.theme.campFinderWidget.firstSport;
      }

      $(`.location-sports-cta`).attr('hidden', 'true');
      $(`.location-sports-cta[data-cta-location="${initialFilters.city}"][data-cta-sport="${initialFilters.sport}"]`).removeAttr('hidden');

      let initialMatchedCamps = filterCamps(initialFilters);

      $('.results-count__text .results-count').text(initialMatchedCamps.length);

      // Apply sorting on initial load
      if (isBadmintonProgramsPage()) {
        let sortedCamps = sortCamps('badminton-programs');
        $('.camp-cards__list').empty().append(sortedCamps);
      } else {
        // For other pages, apply default sort (ASC camps first, then by start date)
        let sortedCamps = sortCamps('popular');
        $('.camp-cards__list').empty().append(sortedCamps);
      }

      // Update map's lat/lng using the first city's lat/lng
      let $mapWrapper = getMapWrapper();

      $mapWrapper.data(
        'lat',
        $highestPriorityFilter.find('.camp-list__filter').data('lat'),
      );
      $mapWrapper.data(
        'lng',
        $highestPriorityFilter.find('.camp-list__filter').data('lng'),
      );
    }

    $('body').on('click', '.camp-list__filter', function (e) {
      e.preventDefault();
      let sport = $(this).data('sportFilter');
      let sortFilter = $('.sort-filter');
      let city =
        $(this).data('cityFilter') ??
        window.theme.campFinderWidget.pageCityName;

      $('.camp-list__filter-slide').toggleClass('active', false);

      if (sport) filters.sport = sport;
      if (city) {
        filters.city = city;
        currentCityTab = city;
      }

      filters.week = jQuery(`select[name="week_filter"]`).eq(0).val() ?? 'all';
      $(`.location-sports-cta`).attr('hidden', 'true');
      $(`.location-sports-cta[data-cta-location="${filters.city}"][data-cta-sport="${filters.sport}"]`).removeAttr('hidden');

      map.setFilters(filters);

      filterCamps(filters);

      const matchedCamps = filterCamps(filters).length;

      $('.results-count__text .results-count').text(matchedCamps);

      $(this).closest('.camp-list__filter-slide').toggleClass('active', true);

      $(this).closest('.swiper').prop('swiper').slideTo($(this).index());

      sortFilter.val('popular');

      $('.camp-list__results-wrapper').removeClass('no-camps-for-duration');

      // Use badminton-programs sort if on that page, otherwise use 'popular'
      let initialSort = isBadmintonProgramsPage()
        ? 'badminton-programs'
        : 'popular';
      let sortedCamps = sortCamps(initialSort);

      $('.camp-cards__list').empty().append(sortedCamps);
    });

    // Enable Sort By filtering
    document.querySelector('.sort-filter').addEventListener('change', (e) => {
      let sortedCamps = sortCamps(e.target.value);

      $('.camp-cards__list').empty().append(sortedCamps);

      $('.results-count__text .results-count').text(matchedCamps.length);
    });

    /**
     * Filter camps based on the provided params
     * @param {Object} params
     *
     * @param {String} [params.week] The week to filter by
     * @param {String} [params.sport] The sport to filter by
     * @param {String} [params.city] The city to filter by
     * @returns {Array} Array of camps that matched the filter
     */
    function filterCamps(params) {
      let matchedCamps = [];

      let _defaults = {
        week: 'all',
        sport: 'all',
        city: 'all',
      };

      // Ensure no undefined values make it through
      Object.keys(params).forEach((key) =>
        params[key] === undefined ? delete params[key] : {},
      );

      params = Object.assign({}, _defaults, params);

      $('.camp-card__wrapper').each(function () {
        let $campCard = $(this);

        let campWeek = $campCard.data('week');
        let campCity = $campCard.data('city');
        let campSport = $campCard.data('sport');

        let matched =
          (campWeek == params.week || params.week == 'all') &&
          (params.city == 'all' || campCity == params.city) &&
          (params.sport == 'all' || campSport == params.sport);

        $campCard
          .closest('.camp-card__hitpoint')
          .toggleClass('hidden', !matched);

        if (matched) matchedCamps.push($campCard);
      });

      return matchedCamps;
    }

    const listOfCamps = $('.camp-card__hitpoint').toArray();

    // Check if we're on a badminton-programs page
    function isBadmintonProgramsPage() {
      return (
        window.location.pathname.includes('/pages/') &&
        window.location.pathname.includes('badminton-programs')
      );
    }

    // Parse start date for sorting (expects date string in format like "2024-01-15" or similar)
    function parseStartDate(campElement) {
      const $camp = $(campElement);
      // Try both data() and attr() since jQuery's data() converts kebab-case
      let startDateStr =
        $camp.data('camp-start-date') ||
        $camp.data('campStartDate') ||
        $camp.attr('data-camp-start-date');

      if (!startDateStr || startDateStr === '') {
        return new Date(0); // Return epoch date if no date found
      }

      // Try parsing the date
      const date = new Date(startDateStr);
      if (isNaN(date.getTime())) {
        // If date parsing fails, try to parse common date formats
        // Handle dates like "2024-01-15" or "01/15/2024" or "2024-01-15T00:00:00"
        const cleanedDate = startDateStr.trim();
        const parsedDate = new Date(cleanedDate);
        if (isNaN(parsedDate.getTime())) {
          return new Date(0); // Return epoch if still can't parse
        }
        return parsedDate;
      }
      return date;
    }

    function sortCamps(sort) {
      const listOfVisibleCamps = $(
        '.camp-card__hitpoint:not(.hidden)',
      ).toArray();
      let sortedListofCamps = [...listOfCamps];

      //Check if camps of sepcific duration exist
      function checkForCampsByDuration(durationToCheck, threePlusDays = false) {
        const hasCamps = listOfVisibleCamps.some((camp) => {
          let duration = Number(
            $(camp).find('[data-duration]').first().data('duration'),
          );
          if (!threePlusDays) {
            return duration === durationToCheck;
          } else {
            return duration >= durationToCheck;
          }
        });

        //Conditionally display no results message
        const campListWrapper = $('.camp-list__results-wrapper');
        if (!hasCamps) {
          campListWrapper.addClass('no-camps-for-duration');
        } else {
          campListWrapper.removeClass('no-camps-for-duration');
        }

        return hasCamps;
      }

      // Sort camps by duration
      function sortByDuration(
        a,
        b,
        targetDuration = null,
        threePlusDescending = false,
      ) {
        let campCardA = $(a).find('[data-duration]').data('duration');
        let campCardB = $(b).find('[data-duration]').data('duration');

        // Order camps with durations >= 3 days first
        if (threePlusDescending) {
          const campCardA3Plus = campCardA >= 3;
          const campCardB3Plus = campCardB >= 3;
          if (campCardA3Plus && !campCardB3Plus) return -1;
          if (!campCardA3Plus && campCardB3Plus) return 1;
          if (campCardA3Plus && campCardB3Plus) return campCardB - campCardA;
          return 0;
        }

        // Order camps with durations 1 or 2 day durations first
        if (targetDuration !== null) {
          if (campCardA == targetDuration && campCardB != targetDuration)
            return -1;
          if (campCardA != targetDuration && campCardB == targetDuration)
            return 1;
        }

        // Re order rest of camps below
        return campCardA - campCardB;
      }

      // Custom sort for badminton-programs pages: duration descending (3-day, 2-day, 1-day), then by start date
      function sortBadmintonPrograms(a, b) {
        const durationA =
          Number($(a).find('[data-duration]').data('duration')) || 0;
        const durationB =
          Number($(b).find('[data-duration]').data('duration')) || 0;

        // First sort by duration descending (3-day first, then 2-day, then 1-day)
        if (durationA !== durationB) {
          return durationB - durationA; // Descending order
        }

        // If durations are equal, sort by start date ascending
        const startDateA = parseStartDate(a);
        const startDateB = parseStartDate(b);
        return startDateA - startDateB;
      }

      // Check if a camp is an ASC camp (not partner or CSC)
      function isASCCamp(campElement) {
        const $hitpoint = $(campElement);
        // Partner camps have 'partner-camp' class on hitpoint
        // CSC camps have 'csc-camp' class on hitpoint
        // ASC camps don't have these classes and have 'camp-card__asc-camp' class on wrapper
        const isPartner = $hitpoint.hasClass('partner-camp');
        const isCSC = $hitpoint.hasClass('csc-camp');

        // If it's partner or CSC, it's not ASC
        if (isPartner || isCSC) return false;

        // Check if the wrapper has the asc-camp class
        const $wrapper = $hitpoint.find('.camp-card__wrapper');
        const wrapperClass = $wrapper.attr('class') || '';
        const hasASCCampClass = wrapperClass.includes('asc-camp');

        return hasASCCampClass;
      }

      // Sort for other pages: ASC camps first, then by start date
      function sortDefault(a, b) {
        const isASCA = isASCCamp(a);
        const isASCB = isASCCamp(b);

        // ASC camps come first
        if (isASCA && !isASCB) return -1;
        if (!isASCA && isASCB) return 1;

        // If both are same type, sort by start date ascending
        const startDateA = parseStartDate(a);
        const startDateB = parseStartDate(b);

        // Compare dates - if both are epoch (invalid), keep original order
        if (startDateA.getTime() === 0 && startDateB.getTime() === 0) {
          return 0;
        }
        // Dates with epoch come last
        if (startDateA.getTime() === 0) return 1;
        if (startDateB.getTime() === 0) return -1;

        return startDateA.getTime() - startDateB.getTime();
      }

      // Switch case to apply different sort conditions to the visible list of camps
      switch (sort) {
        case 'popular':
          // Apply badminton-programs custom sort if on that page
          if (isBadmintonProgramsPage()) {
            return [...sortedListofCamps].sort(sortBadmintonPrograms);
          }
          // For other pages, sort by ASC camps first, then by start date
          return [...sortedListofCamps].sort(sortDefault);
        case 'price_low_to_high':
          return [...sortedListofCamps].sort(
            (a, b) =>
              $(a).find('[data-price]').data('price') -
              $(b).find('[data-price]').data('price'),
          );
        case 'price_high_to_low':
          return [...sortedListofCamps].sort(
            (a, b) =>
              $(b).find('[data-price]').data('price') -
              $(a).find('[data-price]').data('price'),
          );
        case 'duration_1_day': {
          if (checkForCampsByDuration(1)) {
            return [...sortedListofCamps].sort((a, b) =>
              sortByDuration(a, b, 1),
            );
          } else {
            return listOfCamps;
          }
        }

        case 'duration_2_day': {
          if (checkForCampsByDuration(2)) {
            return [...sortedListofCamps].sort((a, b) =>
              sortByDuration(a, b, 2),
            );
          } else {
            return listOfCamps;
          }
        }

        case 'duration_3_plus_days': {
          if (checkForCampsByDuration(3, true)) {
            return [...sortedListofCamps].sort((a, b) =>
              sortByDuration(a, b, null, true),
            );
          } else {
            return listOfCamps;
          }
        }
        case 'badminton-programs':
          // Custom sort for badminton-programs pages
          return [...sortedListofCamps].sort(sortBadmintonPrograms);
      }
    }

    // Sync all week selectors
    $(`select[name="week_filter"]`).on('change', function () {
      $(`select[name="week_filter"]`).val($(this).val());

      filters.week = $(this).val();
      filters.city = currentCityTab;
      let matchedCamps = filterCamps(filters);

      $('.results-count__text .results-count').text(matchedCamps.length);

      // Apply the current sort (or badminton-programs sort if on that page and popular is selected)
      let currentSort = $('.sort-filter').val() || 'popular';
      if (isBadmintonProgramsPage() && currentSort === 'popular') {
        currentSort = 'badminton-programs';
      }
      let sortedCamps = sortCamps(currentSort);
      $('.camp-cards__list').empty().append(sortedCamps);

      updateMapMarkers();
    });

    $('.view-map-cta').on('click', function (e) {
      e.preventDefault();

      $('.camp-list__map-overlay').toggleClass('active', true);
    });

    $('.camp-list__close-map-cta').on('click', function (e) {
      e.preventDefault();

      $('.camp-list__map-overlay').toggleClass('active', false);
    });

    $('.open-partner-modal').on('click', function (e) {
      e.preventDefault();

      $('.partner-modal__viewport').toggleClass('active', true);
    });

    $('.close-partner-modal').on('click', function (e) {
      e.preventDefault();

      $('.partner-modal__viewport').toggleClass('active', false);
    });

    let filtersSwiper = new Swiper(
      '.camp-list__filters-carousel.swiper:not(.swiper-initialized)',
      {
        slidesPerView: 'auto',
        spaceBetween: 16,
      },
    );

    $(window).on('resize', function () {
      if (window.innerWidth > 1280) {
        $('.camp-list__map-overlay').toggleClass('active', false);
      }

      // Update map's lat/lng using the active city's lat/lng
      let $mapWrapper = getMapWrapper();

      let $activeFilter = $('.camp-list__filter-slide.active');

      if (!$activeFilter.length) return;

      $mapWrapper.data(
        'lat',
        $activeFilter.find('.camp-list__filter').data('lat'),
      );
      $mapWrapper.data(
        'lng',
        $activeFilter.find('.camp-list__filter').data('lng'),
      );

      filtersSwiper.update();

      initMap();
    });

    async function initMap(initialFilters) {
      let mapWrapper = getMapWrapper();
      if (!mapWrapper.length) return;

      // Don't re-initialize the map if it's already initialized
      if (map) map.getMap().remove();

      map = new MapRenderer({
        container: mapWrapper.get(0),
        attributionControl: false,
        center: {
          lat: parseFloat(mapWrapper.data('lat')),
          lng: parseFloat(mapWrapper.data('lng')),
        },
        zoom: 11,
        mapId: 'e0d4f7b4b7d1f1a4',
        geojson: window.theme.campGeojsonData,
        filters: initialFilters,
      });

      mapWrapper.get(0).addEventListener('map:pin-click', function (e) {
        console.debug('map:pin-click');
        console.log(e.detail);

        jQuery('.result-column.products .camp-card__wrapper').removeClass(
          'selected',
        );

        const matchingCampCard = jQuery(
          '.result-column.products .camp-card__wrapper[data-variant-id="' +
            e.detail.properties.id +
            '"]',
        );

        if (matchingCampCard.length) matchingCampCard.addClass('selected');

        matchingCampCard.get(0).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }

    let initialFilters = {};

    processInitialFilters(initialFilters);

    initMap(initialFilters);
  });
});
